import ApiFiles from 'services/api_files';
import Api from '../api';

export const getFilters = async () => {
  const response = await Api.get('boletim_web/public/boletins.json');

  return response.data;
};

export const getDownloadBulletin = async (
  file_extension: string,
  document_type: 'followup' | 'bidding',
  bulletin_id: number,
  item_ids: Array<number>,
  issue: number,
  filter_name: string,
) => {
  let params = '';

  if (document_type === 'followup') params = `&followups_ids=${item_ids.join(',')}`;
  if (document_type === 'bidding') params = `&biddings_ids=${item_ids.join(',')}`;
  if (item_ids.length === 0) params = '';

  const url = `/boletim_web/public/boletins/${bulletin_id}/print.${file_extension}?${params}`;

  const response = await ApiFiles.get(url);

  const objectUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = objectUrl;
  link.setAttribute('download', `boletim_web_${filter_name}_${issue}.${file_extension}`);
  document.body.appendChild(link);
  link.click();
};

export const getPrintBulletin = async (
  document_type: 'followup' | 'bidding',
  bulletin_id: number,
  item_ids: Array<number>,
) => {
  let params = '';
  const { REACT_APP_API_ENDPOINT } = process.env;

  if (document_type === 'followup') params = `&followups_ids=${item_ids.join(',')}`;
  if (document_type === 'bidding') params = `&biddings_ids=${item_ids.join(',')}`;
  if (item_ids.length === 0) params = '';

  const url = `${REACT_APP_API_ENDPOINT}/boletim_web/public/boletins/${bulletin_id}/print.html?${params}`;

  window.open(url);
};

export const sendInlineBulletin = async (bulletinFilterId: number) => {
  const params = {
    bulletin_filter_id: bulletinFilterId,
  };
  const response = await Api.post(
    `${process.env.REACT_APP_API_ENDPOINT}/boletim_web/public/send_inline_bulletin`,
    params,
  );

  return response.status;
};
